import { render, staticRenderFns } from "./rewardFloor.vue?vue&type=template&id=63c2d6be&scoped=true&"
import script from "./rewardFloor.vue?vue&type=script&lang=js&"
export * from "./rewardFloor.vue?vue&type=script&lang=js&"
import style0 from "./rewardFloor.vue?vue&type=style&index=0&id=63c2d6be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c2d6be",
  null
  
)

export default component.exports